import {Trans} from '@lingui/macro';
import React from 'react';

import {SettingsBannersEnum, useSettingsBanners} from '../banners/settingsBannersContext';

export function useSettingsInboxesBanners() {
  const {showBanner} = useSettingsBanners();

  return {
    showBusinessHoursUpdateBanner: () =>
      showBanner({
        type: SettingsBannersEnum.SUCCESS,
        message: (
          <Trans id="settingsinboxesbanner-business-hours-update">Business hours have been updated.</Trans>
        ),
      }),
    showUpdateBanner: (inboxName: string) =>
      showBanner({
        type: SettingsBannersEnum.SUCCESS,
        message: (
          <Trans id="settingsinboxesbanner-update">
            Your inbox &quot;{inboxName}&quot; has been updated.
          </Trans>
        ),
      }),
    showCreationgBanner: (inboxName: string) =>
      showBanner({
        type: SettingsBannersEnum.SUCCESS,
        message: (
          <Trans id="settingsinboxesbanner-created">
            Your inbox &quot;{inboxName}&quot; has been created.
          </Trans>
        ),
      }),
  };
}
